import { Box, Flex } from '@chakra-ui/react';

import { CloseIcon, PlusIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import ButtonSolid from 'UiKit/button/buttonSolid';
import FilterSelect from 'UiKit/filter-select';
import useGetArea from 'Domain/studio/useGetArea';
import useGetApplicationType from 'Domain/studio/useGetApplicationType';
import { filterStudioText } from 'Const/studio/text';
import SearchComponent from 'UiKit/search';
import { TextSemiBold } from 'UiKit/typography';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import { useStudioState } from 'View/studio/state';
import checkIsResetAllFilter from 'View/studio/helper/checkIsResetAllFilter';

import styles from './styles.module.css';

const Filter = () => {
  const accessPermission = getMenuPermissions('master-data', 'studio');
  const { data: optionsArea, isloading: isLoadingOptionArea } = useGetArea();
  const { data: optionsApplicationType, isLoading: isLoadingOptionApplicationType } = useGetApplicationType();
  const { updateState, filterState, updateFilterState, resetFilterState } = useStudioState();

  const isResetAllFilter = checkIsResetAllFilter(filterState);
  const onChangeFilter = (newFilter) => updateFilterState({ ...newFilter, page: 1 });
  const resetFilter = () => resetFilterState();

  return (
    <Flex className={styles['filter-studio__wrapper']}>
      <Flex className={styles['filter-studio__container']}>
        <Flex className={styles['left__section']} gap={'12px'}>
          <SearchComponent value={filterState?.search} onSearch={(value) => onChangeFilter({ search: value })} maxWidth="337px" />

          <Box>
            <FilterSelect
              value={filterState?.area}
              onChange={(value) => onChangeFilter({ area: value })}
              placeholder={filterStudioText.areaPlaceholder}
              clearable={true}
              options={optionsArea}
              isLoading={isLoadingOptionArea}
              width="125px"
            />
          </Box>

          <Box>
            <FilterSelect
              value={filterState?.appType}
              onChange={(value) => onChangeFilter({ appType: value })}
              placeholder={filterStudioText.applicationTypePlaceholder}
              clearable={true}
              options={optionsApplicationType}
              isLoading={isLoadingOptionApplicationType}
              width="163px"
            />
          </Box>

          <Condition statement={isResetAllFilter}>
            <Flex onClick={resetFilter} className={styles['reset-filter__container']}>
              <CloseIcon size="14px" color="var(--color-semantic-text)" />
              <TextSemiBold>Clear Filters</TextSemiBold>
            </Flex>
          </Condition>
        </Flex>

        <Box className={styles['right__section']}>
          <Condition statement={accessPermission?.isCanCreate}>
            <ButtonSolid
              type="button"
              className={styles['filter-studio__button--create']}
              leftIcon={<PlusIcon width="14px" height="14px" />}
              onClick={() => updateState({ isOpenFormUpsert: true })}
            >
              {filterStudioText.createStudioButtonText}
            </ButtonSolid>
          </Condition>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Filter;
